export default "__VITE_ASSET__CqNL6ZSK__"